import DataGrid from "./DataGrid/DataGrid.tsx";

const PolicyInstallmentsDataGrid = ({
  installments,
  isLoading,
  fromDate,
  toDate,
  renderValueFn,
}: {
  installments: any[];
  isLoading: boolean;
  fromDate: string;
  toDate: string;
  renderValueFn?: (key: string, value: any) => any;
}) => {
  const columns = [
    {
      name: "installmentSequence",
      header: "Вноска №",
      type: "number",
      flex: 0.6,
      minWidth: 50,
    },
    {
      name: "installmentDate",
      header: "Падеж дата",
      type: "string",
      flex: 1,
      minWidth: 80,
    },
    {
      name: "installmentAmount",
      header: "Сума вноска",
      type: "string",
      flex: 0.9,
      minWidth: 75,
    },
    {
      name: "paymentLocation",
      header: "Място",
      type: "string",
      flex: 1,
      minWidth: 80,
      render: ({ value }) => {
        if (renderValueFn) return renderValueFn("paymentLocation", value);
        return value || "-";
      },
    },
    {
      name: "accountNumber",
      header: "№ Сметка",
      type: "string",
      flex: 0.9,
      minWidth: 75,
    },
    {
      name: "sticker",
      header: "№ Стикер",
      type: "string",
      flex: 1,
      minWidth: 80,
    },
    {
      name: "stickerAmount",
      header: "Сума стикер",
      type: "string",
      flex: 0.9,
      minWidth: 75,
    },
    {
      name: "twoPercentAmount",
      header: "2%",
      type: "string",
      flex: 0.5,
      minWidth: 40,
    },
    {
      name: "greenCardCertificate",
      header: "СЗК",
      type: "string",
      flex: 0.8,
      minWidth: 65,
    },
    {
      name: "agentId",
      header: "Агент",
      type: "string",
      flex: 1.2,
      minWidth: 95,
      render: ({ value, data }) => {
        // Fallback check in case the object contains a pre-mapped "Agent" text descriptor string
        if (data?.Agent) return data.Agent;
        if (renderValueFn) return renderValueFn("agentId", value);
        return value || "-";
      },
    },
    {
      name: "paidToAgent",
      header: "Пл. Агент",
      type: "string",
      flex: 0.7,
      minWidth: 60,
    },
    {
      name: "reportDate",
      header: "Отчетена",
      type: "string",
      flex: 1,
      minWidth: 80,
    },
    {
      name: "paidToInsurer",
      header: "Пл. ЗК",
      type: "string",
      flex: 0.7,
      minWidth: 60,
    },
    {
      name: "documentNumber",
      header: "№ Док.",
      type: "string",
      flex: 0.8,
      minWidth: 70,
    },
    {
      name: "paidInBank",
      header: "По Банка",
      type: "string",
      flex: 0.7,
      minWidth: 60,
    },
    {
      name: "bankPaymentDate",
      header: "Пл. Банка",
      type: "string",
      flex: 1,
      minWidth: 80,
    },
  ];

  return (
    <DataGrid
      columns={columns}
      dataSource={installments}
      isLoading={isLoading}
      gridTitle="Падежи по вноски"
      idProperty="installmentSequence"
      csvFilename={`Вноски-${fromDate}-${toDate}.csv`}
      icon="fa-kit fa-regular-file-circle-question"
    />
  );
};

export default PolicyInstallmentsDataGrid;
